import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { MortgageApplicationContext } from '../models/mortgage-application-context.model';
import { MortgageApplicationResponse } from '../models/mortgage-application-response.model';
import { MortgageApplication } from '../models/mortgage-application.model';
import { MortgageApplicationService } from './mortgage-application.service';

@Injectable()
export abstract class MortgageApplicationFormService {
  constructor(public mortgageApplicationService: MortgageApplicationService) {}

  initializeMortgageApplication(applicationId: string): Observable<MortgageApplicationResponse> {
    return this.mortgageApplicationService.loadMortgageApplication(applicationId);
  }

  initializeLoanTypes(mortgageApplication: MortgageApplication): Observable<any> {
    return this.mortgageApplicationService.loadAvailableLoanTypes(mortgageApplication);
  }

  abstract initialize(applicationId: string): Observable<any>;

  abstract getCurrentContext(): MortgageApplicationContext;
}
